import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/uikit': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M443.9 128v256l-225.9 128-218-128v-214.3l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1zM308.6 49.1l-87.4 53-86-47.3 88.6-54.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/uikit.js
// module id = 1065
// module chunks = 0